export const profileUrl = 'https://www.strava.com/me'
export const loginUrl = 'https://www.strava.com/login'
// Strava's language settings is at the bottom of every page
export const graphqlUrl = 'https://graphql.strava.com/'
export const homeUrl = 'https://www.strava.com/'
export const privacySettingsUrl = 'https://www.strava.com/settings/privacy'
export const startEndLocationUrl =
  'https://www.strava.com/settings/privacy/hide-anywhere'
